import React from 'react';

export const ListContainer = ({ children }) => {
    return (
        <div className="row">
            <div className="col">
                <ul className="list-group">{children}</ul>
            </div>
        </div>
    );
};
